import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface AutofocusEffectProperties extends EffectProperties {
  bokehScale: number;
  focusRange: number;
  focusDistance: number;
}

// Create a reusable Autofocus component that can be used in both preview and world
const AutofocusComponent = forwardRef<any, { properties: AutofocusEffectProperties; isPreview?: boolean }>((props, ref) => {
  
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }

  const { bokehScale, focusRange, focusDistance } = properties;

  return (
    <PostProcessing.Autofocus
      ref={ref}
      bokehScale={bokehScale}
      focusRange={focusRange}
      focusDistance={focusDistance}
    />
  );
});

export const AutofocusEffectItem: Effect<AutofocusEffectProperties> = {
  id: '',
  name: 'Autofocus',
  type: 'effect',
  subtype: 'Autofocus',
  icon: 'Effect',
  properties: {
    bokehScale: 2.0,
    focusRange: 0.1,
    focusDistance: 0.0,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.bokehScale',
      type: 'number',
      label: 'Bokeh Scale',
      default: 2.0,
      min: 0,
      max: 10,
      step: 0.1,
      panel: 'effect',
    },
    {
      key: 'properties.focusRange',
      type: 'number',
      label: 'Focus Range',
      default: 0.1,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    },
    {
      key: 'properties.focusDistance',
      type: 'number',
      label: 'Focus Distance',
      default: 0.0,
      min: 0,
      max: 1,
      step: 0.01,
      panel: 'effect',
    }
  ],
  render: (properties: AutofocusEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <AutofocusComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
}; 